import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { CONFIG } from './services/ChatService';
import { applyTheme } from './ThemeDefaults';

function getUrlParameter(name) {
  if (typeof window === 'undefined') return null;
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

const defaultConfig = {
  apiBaseUrl: null,
  masterId: null,
  elementId: 'cms-qa-chat-container',
  language: 'ja',
  theme: {},
  // 入力欄のカスタマイズ
  inputRows: 1,
  placeholder: 'メッセージを入力してください...',
  // UI テキストのカスタマイズ
  headerTitle: 'CMS QA Chat',
  sendButtonText: '送信',
};

let chatInstance = null;

export function initCmsQaChat(config = {}) {
  const mergedConfig = { ...defaultConfig, ...config };

  if (mergedConfig.apiBaseUrl) {
    CONFIG.API_BASE_URL = mergedConfig.apiBaseUrl;
  }

  if (!mergedConfig.masterId) {
    console.error('config.masterId is required');
    return null;
  }

  const container = document.getElementById(mergedConfig.elementId);
  if (!container) {
    console.log("Element not found");
    return null;
  }

  // テーマのCSS変数をコンテナに適用
  applyTheme(container, mergedConfig.theme || {});

  // 创建根实例并渲染组件
  const root = createRoot(container);
  root.render(
    <App
      masterId={mergedConfig.masterId}
      inputRows={mergedConfig.inputRows}
      placeholder={mergedConfig.placeholder}
      headerTitle={mergedConfig.headerTitle}
      sendButtonText={mergedConfig.sendButtonText}
    />
  );

  chatInstance = {
    container,
    destroy: () => {
      // 卸载组件
      root.unmount();
      chatInstance = null;
    },
    /**
     * テーマを動的に更新する
     * @param {Object} newTheme - 更新するテーマ値
     */
    updateTheme: (newTheme) => {
      applyTheme(container, newTheme);
    }
  };

  return chatInstance;
}

export function getCurrentInstance() {
  return chatInstance;
}

const CmsQaChat = {
  initCmsQaChat,
  init: initCmsQaChat,
  getCurrentInstance,
  getInstance: getCurrentInstance
};

if (typeof window !== 'undefined') {
  window.CmsQaChat = CmsQaChat;
}

export default CmsQaChat;
